import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Gift, Ticket } from 'lucide-react';

// Import the existing page components
import AdminRewardsContent from './AdminRewardsPage';
import AdminRafflesPage from './AdminRafflesPage';

export default function AdminRewardsHubPage() {
  const [activeTab, setActiveTab] = useState('rewards');

  return (
    <div className="space-y-6" data-testid="admin-rewards-hub-page">
      <div>
        <h1 className="font-heading text-2xl font-bold">Rewards & Gamification</h1>
        <p className="text-muted-foreground">Manage rewards and raffles</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2 lg:w-auto lg:inline-flex">
          <TabsTrigger value="rewards" className="flex items-center gap-2">
            <Gift className="h-4 w-4" />
            <span className="hidden sm:inline">Rewards</span>
          </TabsTrigger>
          <TabsTrigger value="raffles" className="flex items-center gap-2">
            <Ticket className="h-4 w-4" />
            <span className="hidden sm:inline">Raffles</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="rewards" className="mt-6">
          <AdminRewardsContent embedded />
        </TabsContent>
        <TabsContent value="raffles" className="mt-6">
          <AdminRafflesPage embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}
